import { customRequest } from '@/shared/utils'
import {
    IPersonalDetail,
    IPersonalDetailBody,
    IVerificationSendBody,
    IVerificationVerifyBody,
} from '@/entities/cabinet'
import { computeParams } from '@/shared/utils/to-params'

const enum API_URL {
    userDetails = '/api/v1/users/profile/details/',
    changeDetails = '/api/v1/users/profile/details/update/',
    verificationSend = '/api/v1/users/verification_code/send/',
    verifyCode = '/api/v1/users/verification_code/verify/',
    poolSettings = '/api/v1/sub_accounts/default_pool_commissions/',
    users = '/api/admin/v1/sub_accounts/user/all/',
    currentUserStatus = '/api/admin/v1/sub_accounts/my_level/',
    usersVerification = '/api/admin/v1/sub_accounts/user/verification_required_users/',
    verify = '/api/admin/v1/sub_accounts/user/verify/',
    commission = '/api/admin/v1/sub_accounts/user/commission/',
}
export function getUserDetailApi() {
    return customRequest
        .getItem<IPersonalDetail, any>(API_URL.userDetails)
        .then((res) => res.data)
}

export function updateUserDetailsApi(form: IPersonalDetailBody) {
    return customRequest.patch(API_URL.changeDetails, form)
}

export function verificationSend(form: IVerificationSendBody) {
    return customRequest.post(API_URL.verificationSend, form)
}

export function verificationVerify(form: IVerificationVerifyBody) {
    return customRequest
        .post(API_URL.verifyCode, form)
        .then((res: any) => res.data)
}
export function poolSettings() {
    return customRequest.getItem(API_URL.poolSettings).then((res) => res.data)
}

export function getUsersRequest(query: any) {
    return customRequest
        .getItem(API_URL.users + computeParams(query))
        .then((res) => res.data)
}

export function verifyUser(body: {
    user_id: number
    verification_status: number // 1 - verify, 0 - refuse
    refuse_reason?: string
}) {
    return customRequest.post(API_URL.verify, body)
}

export function getUsersVerificationRequest(query: any) {
    return customRequest
        .getItem(API_URL.usersVerification + computeParams(query))
        .then((res) => res.data)
}

export function getCurrentUserLevel() {
    return customRequest
        .getItem(API_URL.currentUserStatus)
        .then((res) => res.data)
}

export const editCommissionUser = (body: {
    user_id: number
    commission: number
}) => {
    return customRequest.post(API_URL.commission, body)
}

export const openPDF = async (targetUrl: string) => {
    try {
        const response = (await customRequest.getItem(targetUrl, '', {
            responseType: 'blob',
        })) as any
        const url = window.URL.createObjectURL(
            new Blob([response.data], { type: 'application/pdf' })
        )

        window.open(url, '_blank')

        // Optionally, revoke the object URL after some time to free memory
        setTimeout(() => window.URL.revokeObjectURL(url), 10000)
    } catch (err) {
        console.error(err)
    }
}
